import React, { useState, useEffect } from "react";
import axios from "axios";
import "antd/dist/antd.css";
import { DatePicker, Space } from "antd";
import moment , { isSameOrAfter }  from "moment";
import { useParams } from 'react-router-dom';
import withAuthRedirect from "../components/withAuthRedirect";
import Room from "../components/Room";
import Loader from "../components/Loader";
import Error from "../components/Error";

import AOS from "aos";
import "aos/dist/aos.css"; // You can also use <link> for styles
// ..
AOS.init({
  duration: 1000,
});

const { RangePicker } = DatePicker;

function HotelDetails() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [rooms, setRooms] = useState([]);
  const [fromDate, setFromDate] = useState();
  const [toDate, setToDate] = useState();
  const [duplicateRooms, setDuplicateRooms] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [type, setType] = useState("all");
  const { hotelid } = useParams();

//   useEffect(() => {
//     async function fetchMyAPI() {
//       try {
//         setError("");
//         setLoading(true);
//         const data = (await axios.get("/api/rooms/getallrooms")).data;
//         //console.log(data);
//         setRooms(data);
//         setDuplicateRooms(data);
//       } catch (error) {
//         console.log(error);
//         setError(error);
//       }
//       setLoading(false);
//     }

//     fetchMyAPI();
//   }, []);

console.log("hotelid:",hotelid);
  useEffect(() => {
    // Example API request:
    fetch(`/api/hotels/rooms/${hotelid}`)
      .then((response) => response.json())
      .then((data) =>  {
            setRooms(data);
            setDuplicateRooms(data);
        })
      .catch((error) => console.error(error))
      .finally(() => {
      setLoading(false); 
    });
  }, [hotelid]);

console.log("hotelid room :",rooms);


  function filterByDate(dates) {
    console.log(moment(dates[0]).format("YYYY-MM-DD"));
    console.log(moment(dates[1]).format("YYYY-MM-DD"));
    try {
      setFromDate(moment(dates[0]).format("YYYY-MM-DD"));

      setToDate(moment(dates[1]).format("YYYY-MM-DD"));
      // if (isSameOrAfter(fromDate, toDate)) {
      //   setFromDate(null);
      //   console.error(fromDate,toDate);
      //   setToDate(null);
      //   alert("Please select a valid date range.");
      // }


      var tempRooms = [];
      for (const room of duplicateRooms) {
        var availability = false;
        if (room.currentbookings.length > 0) {
          for (const booking of room.currentbookings) {
            if (
              !moment(moment(dates[0]).format("YYYY-MM-DD")).isBetween(
                booking.fromdate,
                booking.todate
              ) &&
              !moment(moment(dates[1]).format("YYYY-MM-DD")).isBetween(
                booking.fromdate,
                booking.todate
              )
            ) {
              if (
                moment(dates[0]).format("YYYY-MM-DD") !== booking.fromdate &&
                moment(dates[0]).format("YYYY-MM-DD") !== booking.todate &&
                moment(dates[1]).format("YYYY-MM-DD") !== booking.fromdate &&
                moment(dates[1]).format("YYYY-MM-DD") !== booking.todate
              ) {
                availability = true;
              }
            }
          }
        }
        //
        if (availability === true || room.currentbookings.length === 0) {
          tempRooms.push(room);
        }
      }
      setRooms(tempRooms);
    } catch (error) {}
  }

  function filterBySearch() {
    const tempRooms = duplicateRooms.filter((x) =>
      x.name.toLowerCase().includes(searchKey.toLowerCase())
    );
    setRooms(tempRooms);
  }
  function filterByType(type) {
    setType(type);
    console.log(type);
    if (type !== "all") {
      const tempRooms = duplicateRooms.filter(
        (x) => x.type.toLowerCase() == type.toLowerCase()
      );
      setRooms(tempRooms);
    } else {
      setRooms(duplicateRooms);
    }
  }

  return (
    <div className="container">
      <div className="row mt-5 bs">
        <div className="col-md-3">
          <RangePicker format="YYYY-MM-DD" onChange={filterByDate} disabledDate={(current) => current && current < moment().startOf('day')} />
        </div>

        <div className="col-md-5">
          <input
            type="text"
            className="form-control"
            placeholder="search rooms"
            value={searchKey}
            onChange={(e) => {
              setSearchKey(e.target.value);
            }}
            onKeyUp={filterBySearch}
          />
        </div>
        <div className="col-md-3">
          <select
            className="form-control"
            value={type}
            onChange={(e) => {
              filterByType(e.target.value);
            }}
          >
            <option value="all">All</option>
            <option value="deluxe">Deluxe</option>
            <option value="non-deluxe">Non-Deluxe</option>
            <option value="other">Other</option>

          </select>
        </div>
      </div>

      <div className="row justify-content-center mt-5">
        {loading ? (
          <Loader></Loader>
        ) : error.length > 0 ? (
          <Error msg={error}></Error>
        ) : (
          rooms.map((x) => {
            return (
              <div className="col-md-9 mt-3" data-aos="zoom-down" key={x._id}>
                <Room room={x} fromDate={fromDate} toDate={toDate} key={x._id}/>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default withAuthRedirect(HotelDetails);
